import type React from 'react';

function AdlibrisIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 830.12 830.12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Adlibris Icon</title>

      <g id="Layer_1-2" data-name="Layer 1">
        <rect width="830.12" height="830.12" fill="none" />
        <path d="M136.31,9.04H695.27v27.76c0,168.05-.26,336.1,.38,504.15,.07,17.99-5.23,30.52-18.02,43.12-74.52,73.43-148.15,147.75-222.14,221.71-20.42,20.41-60.62,20.39-81.07-.05-75.14-75.14-150.47-150.1-224.94-225.9-7.69-7.83-14.31-20.81-14.37-31.44-.88-172.99-.64-345.98-.55-518.98,0-6.4,1.07-12.79,1.75-20.39Zm102.71,102.75V488.12c67.82,2.99,126.21,26.52,176.12,72.6,50.34-46.98,109.13-69.45,175.65-72.86V112.04c-70.05-2.58-126.01,27.17-176.29,69.63-51.04-44.46-106.64-71.31-175.48-69.88Z" />
      </g>
    </svg>
  );
}

export default AdlibrisIcon;
